<template>
  <div class="slider-block">
    <swiper
      :slides-per-view="1"
      :modules="modules"
      :navigation="{ nextEl: '.sld1-next', prevEl: '.sld1-prev' }"
      :pagination="{ clickable: true }"
      :autoplay="{
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }"
    >
      <swiper-slide>
        <div class="swiper-slide slider-item slide-mob-position8" style="background-image: url(/images/slider/8.webp)">
          <div class="slider-item-w">
            <div class="slider-title-wrap">
              <div class="slider-title">Бонусы</div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="slider-item" style="background-image: url(/images/slider/10.webp)">
          <div class="slider-item-w">
            <div class="slide-form">
              <div class="slider-banner">
                <div class="slider-banner-label">Лучшая</div>
                <div class="slider-banner-title">Многоуровневая система бонусов</div>
                <div class="slider-banner-title2">Бонусы при<br />достижении уровня</div>
                <div class="slider-banner-images">
                  <span><img :src="require('@/assets/images/slider-banner1.svg')" alt="" />MacBook</span>
                  <span><img :src="require('@/assets/images/slider-banner2.svg')" alt="" />iPhone</span>
                </div>
                <router-link
                  :to="{ name: 'register' }"
                  class="mob-reg-slider-btn registration-btn only-open-reg"
                  v-if="!isAuthenticated"
                  >Регистрация</router-link
                >
                <router-link :to="{ name: 'levels' }" class="slider-banner-btn">Подробнее</router-link>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="slider-item slider11-0" style="background-image: url(/images/slider/11.webp)">
          <div class="slider-item-w">
            <div class="slide-form">
              <div class="slider-banner-li-2">
                <ul>
                  <li>Новости</li>
                  <li>Фриспины</li>
                  <li>Бонусы</li>
                  <li>Зеркало</li>
                </ul>
              </div>
              <div class="slider-banner slider11">
                <div class="slider-banner-img1">
                  <img :src="require('@/assets/images/slider11.svg')" alt="" />
                  <img :src="require('@/assets/images/slider11-1.svg')" alt="" />
                </div>
                <div class="slider-banner-li">
                  <ul>
                    <li>Новости</li>
                    <li>Бонусы</li>
                    <li>Фриспины</li>
                    <li>Зеркало</li>
                  </ul>
                </div>
                <div class="slider-banner-title2">Подпишись на<br />телеграм канал</div>
                <router-link
                  :to="{ name: 'register' }"
                  class="mob-reg-slider-btn registration-btn only-open-reg"
                  v-if="!isAuthenticated"
                  >Регистрация</router-link
                >
                <a href="https://t.me/millionb_club" class="slider-banner-btn">Подписаться</a>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>

    <div class="sld1-prev slider-arrow" />
    <div class="sld1-next slider-arrow slider-arrow-right" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { useI18n } from 'vue-i18n'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay, Pagination, Navigation } from 'swiper/modules'

export default {
  name: 'SliderBonuses',
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const { t, locale } = useI18n()
    return {
      modules: [Autoplay, Pagination, Navigation],
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated']),
  },
}
</script>

<style scoped></style>
